import { EAttendanceFormKey, EFormItemType, EAttendanceSearchBtns, EColumnType, IColumnBtnKey, EBtnType, EStatusType, } from '@blade-sxp/record-center/interfaces/attendanceRecord';
import lang from '@blade-sxp/record-center/lang/attendanceRecord';
import colors from '@/styles/color.scss';
import { getLangTxt, langTextInit } from '@blade/common/utils/echartUtils';
langTextInit(lang);
export const getSearchFormConfig = () => {
    return {
        sort: [EAttendanceFormKey.KEYWORD, EAttendanceFormKey.STATUS, EAttendanceFormKey.LIB_IDS, EAttendanceFormKey.DATES],
        config: {
            [EAttendanceFormKey.KEYWORD]: {
                key: EAttendanceFormKey.KEYWORD,
                value: '',
                // label: getLangTxt('keyword'),
                type: EFormItemType.INPUT,
                icon: 'el-icon-search',
                placeholder: getLangTxt('keywordTips'),
                width: '25.5rem',
            },
            [EAttendanceFormKey.STATUS]: {
                key: EAttendanceFormKey.STATUS,
                value: '',
                // label: getLangTxt('attendanceStatus'),
                type: EFormItemType.SELECT,
                placeholder: getLangTxt('statusTips'),
                options: [
                    {
                        key: 'normal',
                        label: getLangTxt('normal'),
                        value: EStatusType.NORMAL,
                    },
                    {
                        key: 'late',
                        label: getLangTxt('late'),
                        value: EStatusType.LATE,
                    },
                    {
                        key: 'early',
                        label: getLangTxt('earlyDeparture'),
                        value: EStatusType.EARLY,
                    },
                    {
                        key: 'absence',
                        label: getLangTxt('absence'),
                        value: EStatusType.ABSENCE,
                    },
                    {
                        key: 'lateEarly',
                        label: getLangTxt('lateEarly'),
                        value: EStatusType.LATE_EARLY,
                    },
                ],
                width: '20rem',
            },
            [EAttendanceFormKey.LIB_IDS]: {
                key: EAttendanceFormKey.LIB_IDS,
                value: '',
                // label: getLangTxt('attendanceStatus'),
                type: EFormItemType.LIB_PORTAIT,
                width: '20rem',
            },
            [EAttendanceFormKey.DATES]: {
                key: EAttendanceFormKey.DATES,
                value: [],
                // label: getLangTxt('dates'),
                type: EFormItemType.DATES,
                startTimeTips: getLangTxt('startTime'),
                endTimeTips: getLangTxt('endTime'),
                rangeSeparator: getLangTxt('rangeSeparator'),
                valueFormat: 'yyyy-MM-dd',
            },
        },
    };
};
export const getSearchBtnsConfig = () => {
    return [
        // {
        //   key: EAttendanceSearchBtns.SEARCH,
        //   label: getLangTxt('search'),
        // },
        {
            key: EAttendanceSearchBtns.RESET,
            label: getLangTxt('reset'),
            isPlain: true, // 是否是朴素按钮
        },
        {
            key: EAttendanceSearchBtns.EXPORT,
            label: getLangTxt('export'),
            type: EBtnType.PRIMARY,
            icon: 'export-icon',
        },
    ];
};
export const getColumns = () => {
    return [
        {
            type: '',
            prop: 'name',
            label: getLangTxt('name'),
            minWidth: '10%',
        },
        {
            type: '',
            prop: 'jobNumber',
            label: getLangTxt('jobNum'),
            minWidth: '10%',
        },
        {
            type: '',
            prop: 'department',
            label: getLangTxt('department'),
            minWidth: '10%',
        },
        {
            type: '',
            prop: 'attendanceDate',
            label: getLangTxt('date'),
            minWidth: '10%',
        },
        {
            type: EColumnType.STATUS,
            prop: 'attendanceStatus',
            label: getLangTxt('attendanceStatus'),
            minWidth: '10%',
        },
        {
            type: '',
            prop: 'firstAttendanceTime',
            label: getLangTxt('firstCheck'),
            minWidth: '10%',
        },
        {
            type: '',
            prop: 'endAttendanceTime',
            label: getLangTxt('lastCheck'),
            minWidth: '10%',
        },
        {
            type: '',
            prop: 'workTimeHours',
            label: getLangTxt('workingHours'),
            minWidth: '10%',
        },
        {
            type: '',
            prop: 'overtimeHours',
            label: getLangTxt('overtimeDuration'),
            minWidth: '10%',
        },
        {
            type: EColumnType.BTNS,
            prop: 'operation',
            label: getLangTxt('operation'),
            minWidth: '10%',
            btns: [
                {
                    key: IColumnBtnKey.VIEW,
                    label: getLangTxt('view'),
                    color: colors.buttonTextPrimary,
                },
            ],
        },
    ];
};
export const getPaginationConfig = () => {
    return {
        page: 1,
        size: 10,
        sizes: [10, 20, 50, 100, 200],
        total: 0,
    };
};
export const getAttendanceStatusConfig = () => {
    return {
        [EStatusType.NORMAL]: {
            label: getLangTxt('normal'),
            color: colors.attendanceStatusNormal,
        },
        [EStatusType.LATE]: {
            label: getLangTxt('late'),
            color: colors.attendanceStatusLate,
        },
        [EStatusType.EARLY]: {
            label: getLangTxt('earlyDeparture'),
            color: colors.attendanceStatusEarly,
        },
        [EStatusType.LATE_EARLY]: {
            label: getLangTxt('lateEarly'),
            color: colors.attendanceStatusLateEarly,
        },
        [EStatusType.ABSENCE]: {
            label: getLangTxt('absence'),
            color: colors.attendanceStatusAbsence,
        },
    };
};
